  import React, { useRef, useState } from "react";
  import ReactECharts from "echarts-for-react";
  import { Card, Select } from "antd";
  import "./OverviewDonut.scss";

  const OverviewDonut = ({
    title,
    data,
    labels,
    colors,
    centerLabel,
    centerValue,
    dropdownOptions,
    selectedOption,
    onChange,
  }) => {
    const chartRef = useRef(null);
    const [hoveredLabel, setHoveredLabel] = useState(null);

    const getTriangleCenter = (startAngle, endAngle, activeLabel) => {
      const chartSize = 220;
      const center = chartSize / 2;
      const radius = chartSize * 0.4;

      let left, top, rotation;

      if (activeLabel === "Pending") {
        left = center + radius * Math.cos(-8.5);
        top = center + radius * Math.sin(3);
        rotation = -22;
      } else if (activeLabel === "Allocated") {
        left = center + radius * Math.cos(10.0);
        top = center + radius * Math.sin(-13);
        rotation = 0; // Adjusted to 0 to avoid spinning
      } else if (activeLabel === "Resolved") {
        left = center + radius * Math.cos(-11.1);
        top = center + radius * Math.sin(6);
        rotation = 0; // Adjusted to 0 to avoid spinning
      }

      return {
        left,
        top,
        rotation,
      };
    };

    const getOption = () => {
      const activeLabel = hoveredLabel; // Only use hoveredLabel
      const selectedIndex = labels.indexOf(activeLabel);
      const total = data.reduce((a, b) => a + b, 0);
      const angles = data.map((value) => (value / total) * 360);

      let startAngle = 0;
      const angleMap = angles.map((a) => {
        const result = { start: startAngle, end: startAngle + a };
        startAngle += a;
        return result;
      });

      const selectedAngle = selectedIndex !== -1 ? angleMap[selectedIndex] : null;
      const textPosition =
        activeLabel && selectedAngle
          ? getTriangleCenter(selectedAngle.start, selectedAngle.end, activeLabel)
          : { left: "50%", top: "50%" };

      return {
        tooltip: { trigger: "item" },
        color: colors,
        legend: { show: false },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["55%", "80%"],
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: false },
            emphasis: { disabled: true },
            data: data.map((value, i) => ({
              value,
              name: labels[i],
            })),
            animation: true,
            animationThreshold: 1,
            animationDuration: 500,
            animationEasing: "cubicOut",
          },
          {
            name: "Highlight",
            type: "pie",
            radius: ["0%", "80%"],
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: false },
            z: 0,
            silent: true,
            itemStyle: {
              opacity: 1,
            },
            data: data.map((value, i) => ({
              value,
              name: labels[i],
              itemStyle: {
                color: labels[i] === activeLabel ? colors[i] : "transparent",
                opacity: labels[i] === activeLabel ? 1 : 0,
              },
            })),
            animation: true,
            animationThreshold: 1,
            animationDuration: 300,
            animationEasing: "cubicOut",
          },
        ],
        graphic:
          activeLabel && selectedIndex !== -1
            ? [
                {
                  type: "text",
                  left: "center",
                  top: "center",
                  z: 10,
                  style: {
                    text: `${data[selectedIndex]}\n${activeLabel}`,
                    textAlign: "center",
                    textVerticalAlign: "middle",
                    fill: "#000", // white text
                    fontSize: 14,
                    fontWeight: 600,
                  },
                  transition: ["left", "top"],
                  animationDuration: 300,
                  animationEasing: "cubicOut",
                },
              ]
            : [],
      };
    };

    const handleLegendHover = (label) => {
      setHoveredLabel(label);
    };

    const handleLegendLeave = () => {
      setHoveredLabel(null);
    };

    return (
      <Card className="overview-donut-card">
        <div className="overview-donut-header">
          <h3>{title}</h3>
          <Select
            className="selectBox"
            defaultValue={selectedOption}
            style={{ borderRadius: "20px" }}
            options={dropdownOptions}
            onChange={onChange}
          />
        </div>

        <div className="overview-donut-chart">
          <ReactECharts
            ref={chartRef}
            option={getOption()}
            style={{ height: 220, width: 220 }}
          />
        </div>

        <div className="overview-donut-legend">
          {labels.map((label, i) => (
            <div
              key={label}
              className={`legend-item ${
                hoveredLabel === label ? "selected" : ""
              }`}
              onMouseEnter={() => handleLegendHover(label)}
              onMouseLeave={() => handleLegendLeave()}
            >
              <div
                className="color-dot"
                style={{ backgroundColor: colors[i] }}
              ></div>
              <span>{label.toUpperCase()}</span>
            </div>
          ))}
        </div>
      </Card>
    );
  };

  export default OverviewDonut;
